export default __webpack_public_path__ + "static/video-apresentacao-escola-arabe-21d8533d093a21fdd3ab7840065a40b4.mp4";